import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import policy from "./policy";
import auth from "./auth";
import registration from "./registration";
import onlineRenewalReq from "./onlineRenewal";
import enrolGIRONow from "./enrolGIRONow";
import twilio from "./twilio";

export default (history) =>
  combineReducers({
    router: connectRouter(history),
    policy: policy,
    auth: auth,
    registration:registration,
    onlineRenewalReq:onlineRenewalReq,
    enrolGIRONow:enrolGIRONow,
    twilio:twilio
  });
